import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Organizingtee() {
  return (
    <section className="client_expectation p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/teemates/organizing.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={556}
              height={654}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>3. Organize TeeTimes</h2>
            <p>
              Tee times, the golf-centric meetups are reservations of golf
              courses. Users can organize new TeeTimes in the app, exchange
              schedules, update their availability for new tee times, and invite
              other golfers (max four in a batch).
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Organizingtee;
